/* eslint-disable jira/filename-case */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js

// eslint-disable-next-line camelcase -- ERROR TO BE FIXED
export default function murmurhash2_32_gc(str: string): string {
	let l = str.length;
	// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
	let h = l ^ l;
	let i = 0;
	let k;

	while (l >= 4) {
		k =
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			(str.charCodeAt(i) & 0xff) |
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			((str.charCodeAt(++i) & 0xff) << 8) |
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			((str.charCodeAt(++i) & 0xff) << 16) |
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			((str.charCodeAt(++i) & 0xff) << 24);

		// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
		k = (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);
		// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
		k ^= k >>> 24;
		// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
		k = (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);

		// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
		h = ((h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;

		l -= 4;
		++i;
	}

	// eslint-disable-next-line default-case -- ERROR TO BE FIXED
	switch (l) {
		// oxlint-disable-next-line typescript/ban-ts-comment -- ERROR TO BE FIXED
		// @ts-ignore match original source
		case 3:
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
		// oxlint-disable-next-line typescript/ban-ts-comment -- ERROR TO BE FIXED
		// @ts-ignore match original source
		// eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
		case 2:
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
		// eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
		case 1:
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			h ^= str.charCodeAt(i) & 0xff;
			// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
			h = (h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
	}

	// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
	h ^= h >>> 13;
	// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
	h = (h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
	// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
	h ^= h >>> 15;

	// eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
	return (h >>> 0).toString(36);
}
